export default "__VITE_ASSET__DcsUZ$5o__"